import { render, staticRenderFns } from "./CarouselNews.vue?vue&type=template&id=7659bc71&scoped=true"
import script from "./CarouselNews.vue?vue&type=script&lang=js"
export * from "./CarouselNews.vue?vue&type=script&lang=js"
import style0 from "./CarouselNews.vue?vue&type=style&index=0&id=7659bc71&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7659bc71",
  null
  
)

export default component.exports